<ion-item *ngIf="isSuspended" color="warning" class="content-width" lines="none">
    <ion-icon color="secondary" slot="start" name="hourglass"></ion-icon>
    <ion-label>
        <!-- Time since last point: {{ getTimeSinceLastPoint() }} -->
        <p>{{ suspensionItem.note }}</p>
    </ion-label>

    <ion-button (click)="stopSuspension()" slot="end" *ngIf="allowContinueTracking" [disabled]="isSuspending" fill="clear" slot="end">
        <ion-icon *ngIf="!isSuspending" slot="icon-only" name="play"></ion-icon>
        <ion-spinner name="crescent" *ngIf="isSuspending"></ion-spinner>
    </ion-button>
</ion-item>